<template>
  <span class="ui blue label blueLabel">
    <div class="firstInline"><i class="tag icon"></i></div>
    <div class="secondInline">
      <div class="ellipsis" :title="tagname">{{ tagname }}</div>
    </div>
  </span>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

.firstInline {
  display: inline-block;
  vertical-align: middle;
}

.secondInline {
  display: inline-block;
  vertical-align: middle;
  max-width: 80%;
}

.blueLabel {
  max-width: 100%;
}
</style>
<script>
// @flow
export default {
  name: 'change-label',
  props: {
    tagname: {
      type: String,
      default: () => ''
    }
  }
}
</script>
